import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { useEffect, useState } from "react";

export default function ChangePassword({ children }: { children: React.ReactNode }) {   
    const [isOpen, setIsOpen] = useState(false);
    const [password, setPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [newPasswordError, setNewPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        if (!password) { setPasswordError(""); return; }
        if (String(password).length >= 6) { setPasswordError(""); }
        else { setPasswordError("Password must be at least 6 characters long"); }
    }, [password]);

    useEffect(() => {
        if (!newPassword) { setNewPasswordError(""); return; }
        if (String(newPassword).length >= 6) { setNewPasswordError(""); }
        else { setNewPasswordError("Password must be at least 6 characters long"); }
    }, [newPassword]);

    useEffect(() => {
        if (!confirmPassword) { setConfirmPasswordError(""); return; }
        if (confirmPassword === newPassword) { setConfirmPasswordError(""); }
        else { setConfirmPasswordError("Passwords do not match"); }
    }, [confirmPassword, newPassword]);

    useEffect(() => {
        if (password && newPassword && confirmPassword && !passwordError && !newPasswordError && !confirmPasswordError) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    }, [password, newPassword, confirmPassword, passwordError, newPasswordError, confirmPasswordError]);

    const requestPassword = async () => {
        setDisabled(true);
        const response = await fetch('__SITE_BASE__/api/me/profile/password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ oldPassword: password, newPassword }),
        });
        const data = await response.json();
        if (!data.success) {
            setPasswordError(data?.errors?.password);
            setNewPasswordError(data?.errors?.newPassword);
            setDisabled(false);
            if (!data?.errors?.password && !data?.errors?.newPassword) setPasswordError(data.message);
            return;
        }
        setPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setPasswordError("");
        setNewPasswordError("");
        setConfirmPasswordError("");
        setIsOpen(false);
    }
    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger>
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 max-w-96 sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Change Password</DialogTitle>
                    <DialogDescription>Enter your current password and your new password</DialogDescription>
                </DialogHeader>
                <div className="flex flex-col space-y-4">
                    {passwordError && <div className="text-red-500">{passwordError}</div>}
                    <Input
                        type="password"
                        placeholder="Current Password"
                        value={password}
                        className="rounded-lg bg-brand-darkest border-r-0 border-l-0 border-t-0 border-b-brand-green placeholder:text-gray-300"
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    {newPasswordError && <div className="text-red-500">{newPasswordError}</div>}
                    <Input
                        type="password"
                        placeholder="New Password"
                        value={newPassword}
                        className="rounded-lg bg-brand-darkest border-r-0 border-l-0 border-t-0 border-b-brand-green placeholder:text-gray-300"
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                    {confirmPasswordError && <div className="text-red-500">{confirmPasswordError}</div>}
                    <Input
                        type="password"
                        placeholder="Confirm New Password"
                        value={confirmPassword}
                        className="rounded-lg bg-brand-darkest border-r-0 border-l-0 border-t-0 border-b-brand-green placeholder:text-gray-300"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <Button disabled={disabled} onClick={requestPassword} className="bg-brand-green px-5 py-2 w-full mt-4 rounded-lg text-white font-semibold hover:bg-green-500">Change Password</Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}